module.exports = __webpack_public_path__ + "img/idcard.56442472.svg";